/**
 * "Gerar nova proposta" (modo proposta do fornecedor) começa do zero: sem carrinho, sem os dados do simulador da proposta anterior
 * e sem o vínculo com ela. Antes o link novo herdava cep, data, convidados, ref e pid da URL atual e o simulador abria preenchido.
 */
export const NEW_QUOTE_SESSION_KEYS = [
  'ameup_parent_event_id',
  'ameup_event_code',
  'ameup_draft_parent_id',
  'ameup_quote_promoted',
  'ameup_quote_client_name',
  'ameup_quote_client_phone',
  'ameup_shared_quoted_ids',
  'ameup_shared_quoted_items',
  'ameup_is_shared_session',
  'ameup_deferred_pix_days',
  'ameup_quote_only_selected',
  // Dados do simulador e vínculo com a proposta anterior.
  'ameup_event_type',
  'ameup_event_type_locked',
  'ameup_event_type_lock_v2',
  'ameup_special_guests',
  'ameup_store_search',
  'ameup_simulation_id',
  'ameup_shared_parent_id',
  'ameup_shared_ref_code',
  'shared_cart_discount',
  'shared_cart_client_name',
  'supplier_cart_items',
] as const;

/** Endereço da proposta nova: só o modo proposta, nenhum parâmetro da proposta anterior (cep, date, guests, ref, pid, items, nome). */
export const buildNewQuoteUrl = (supplierSlug: string | null | undefined): string =>
  supplierSlug ? `/loja/${supplierSlug}?mode=orcamento` : '/?mode=orcamento';
